import { useParams, useSearchParams } from "react-router-dom";
import AcademyMCQForm from "./AcademyMCQForm";
import AcademyParentForm from "./AcademyParentForm";
import AcademyWritingForm from "./AcademyWritingForm";

const PARENT_KINDS = ["reading-passage", "listening-audio", "speaking-video"];
const CHILD_KINDS = ["reading-question", "listening-question", "speaking-question"];
const FLAT_MCQ_KINDS = ["vocabulary", "grammar"];

export default function AcademyContentForm() {
  const { skillId, kind, id } = useParams();
  const [searchParams] = useSearchParams();
  const parentId = searchParams.get("parent_id");

  if (kind === "writing") return <AcademyWritingForm skillId={skillId} itemId={id} />;
  if (PARENT_KINDS.includes(kind)) return <AcademyParentForm kind={kind} skillId={skillId} itemId={id} />;
  if (FLAT_MCQ_KINDS.includes(kind) || CHILD_KINDS.includes(kind))
    return <AcademyMCQForm kind={kind} skillId={skillId} itemId={id} parentId={parentId} />;

  return <div className="max-w-xl mx-auto py-16 text-center text-red-500">نوع محتوى غير معروف: {kind}</div>;
}